export default __webpack_public_path__ + "static/media/multiplastic.ff5af8cd.png";